import { AGENT_URL } from '../../config/env'
import { fetchJsonWithAuth } from '@/lib/api'
import type {
  IngestionRunFacets,
  IngestionRunsQueryParams,
  IngestionRunsResponse,
} from './types'

export async function getIngestionRuns(
  token: string,
  params: IngestionRunsQueryParams,
  cursor?: string,
  signal?: AbortSignal
): Promise<IngestionRunsResponse> {
  const search = new URLSearchParams()
  if (params.limit) {
    search.set('limit', params.limit.toString())
  }
  if (cursor) {
    search.set('cursor', cursor)
  }
  if (params.sort_by) {
    search.set('sort_by', params.sort_by)
  }
  if (params.sort_order) {
    search.set('sort_order', params.sort_order)
  }
  if (params.filters && params.filters.length > 0) {
    for (const filter of params.filters) {
      const value = filter.value.trim()
      if (!value) continue
      search.append(`filter[${filter.field}][${filter.operator}]`, value)
    }
  }

  return fetchJsonWithAuth<IngestionRunsResponse>({
    token,
    url: `${AGENT_URL}/data/ingestion-runs?${search.toString()}`,
    signal,
    errorMessage: 'Failed to fetch ingestion runs',
  })
}

export async function getIngestionRunFacets(
  token: string,
  signal?: AbortSignal
): Promise<IngestionRunFacets> {
  return fetchJsonWithAuth<IngestionRunFacets>({
    token,
    url: `${AGENT_URL}/data/ingestion-runs/facets`,
    signal,
    errorMessage: 'Failed to fetch ingestion run facets',
  })
}
